<template>
  <div class="footer-box show-flex-box-c">
    <div class="show-flex-box-r">
      <dl class="show-flex-box-r">
        <dt class="show-flex-box-r">
          <img src="../../assets/publick/footter_logo.png" alt="书法家" />
        </dt>
        <dd class="show-flex-box-r">
          <ul class="show-flex-box-r">
            <!-- <li class="show-flex-box-c">
              <em>IOS下载</em>
              <span class="show-flex-box-r">
                <img src="../../assets/data_pic/erweima.png" alt />
              </span>
            </li>
            <li class="show-flex-box-c">
              <em>安卓下载</em>
              <span class="show-flex-box-r">
                <img src="../../assets/data_pic/erweima.png" alt />
              </span>
            </li> -->
            <!-- <li class="show-flex-box-c">
              <em>联系我们</em>
              <strong>010-02937263</strong>
            </li> -->
          </ul>
        </dd>
      </dl>
    </div>
    <dl v-show="showType =='cn'" class="show-flex-box-c show-flex-center">
      <dt><strong>Copyright © zgsftv.cn Rights Reserved 中国书法出版传媒有限责任公司 版权所有</strong>
      </dt>
      <dd class="show-flex-box-r">
        <a href="/web/home/image/propagate_licence" target="_blank">信息网络传播视听节目许可证</a>
        <a href="/web/home/image/program_licence" target="_blank">广播电视节目制作经营许可证</a>
        <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备17021681号-4</a>
      </dd>
    </dl>
    <dl v-show="showType =='com'" class="show-flex-box-c show-flex-center">
      <dt><strong>Copyright © zgsftv.com Rights Reserved 中国书法出版传媒有限责任公司 版权所有</strong>
      </dt>
      <dd class="show-flex-box-r">
        <a href="/web/home/image/propagate_licence" target="_blank">信息网络传播视听节目许可证</a>
        <a href="/web/home/image/program_licence" target="_blank">广播电视节目制作经营许可证</a>
        <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备17021681号-5</a>
      </dd>
    </dl>
  </div>
</template>

<script>
import regex from "@/filter/regex";

export default {
  name: "home",
  data() {
    return {
      showType: '',
      domainName: '',
      companyName: '',
      recordNo: '',
    };
  },
  components: {},
  computed: {
    listenStartupData: function() {
      return this.$store.state.startup;
    },
  },
  mounted() {
    this.setShowTypeByDomain();
    this.setFooterShowInfoByStartUp();
  },
  watch: {
    listenStartupData: function() {
      this.setFooterShowInfoByStartUp();
    },
  },
  methods: {
    setShowTypeByDomain: function() {
      const domain = window.location.host;
      const formatType = {
        '.com': 'com',
        '.cn': 'cn'
      };
      let showType = '';

      for(let key in formatType) {
        if (formatType.hasOwnProperty(key) && domain.indexOf(key) != -1) {
          showType = formatType[key];
        }
      }

      this.showType = showType || 'com';
    },
    setFooterShowInfoByStartUp: function() {
      var startupInfo = this.listenStartupData;
      
      if (!startupInfo) {
        return;
      }

      var siteInfo = startupInfo.site_info || {};

      this.domainName = siteInfo.domain;
      this.companyName = siteInfo.company;
      this.recordNo = siteInfo.record_n_varchar;
    },
    openBeiAnWeb: function() {
      window.open('https://beian.miit.gov.cn/','_blank');
    },
  }
};
</script>
<style lang="less" scoped>
.footer-box {
  height: 100%;
  align-items: center;
  > div {
    width: 1200px;
    height: 206px;
    border-bottom: 1px rgba(255,255,255,0.14) solid;
    > dl {
      width: 100%;
      align-items: center;
      justify-content: space-between;
      > dt {
        width: 205px;
        height: 92px;
        flex-shrink: 0;
        > img {
          display: block;          
          height: 100%;
        }
      }
      >dd{
        flex-shrink: 0;
        >ul{
          // align-items: center;
          >li{
            width: 150px;
            margin-right: 105px;
            >em{
              font-size:14px;
              font-family:PingFangSC-Medium,PingFang SC;
              font-weight:500;
              color:#FFFFFF;
              line-height:20px;
              padding-bottom: 10px;
              border-bottom: 1px rgba(255,255,255,0.14) solid;
              margin-bottom: 15px;
            }
            >span{
             display: block;
             width: 80px;
             height: 80px;
             >img{
               display: block;
               width: 80px;
               height: 80px;
               object-fit: cover;
             } 
            }
            >strong{
              font-size:13px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:#FFFFFF;
              line-height:18px;
            }
          }
          >li:nth-child(3){
            margin-right: 0px;
          }
        }
      }
    }
  }
  >dl{
    width: 100%;
    padding: 15px 0px 40px 0px;
    >dt{
      margin-bottom: 10px;
      >strong{
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:#FFFFFF;
        line-height:17px;
        white-space: nowrap;
      }
    }
    >dd{
      align-items: center;
      >a{
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:#FFFFFF;
        line-height:17px;
        white-space: nowrap;
        flex-shrink: 0;
        margin-right: 15px;
        &:last-child {
          margin-right: 0;
        }
        &:hover{
          text-decoration: underline;
          cursor: pointer;
        }
      }
      >em{
        width:1px;
        height:10px;
        background:rgba(193,190,190,0.39);
        margin: 0px 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publick/footer_cpn.vue